export const COPY = {
  productName: 'CNP PowerForms',
  loading: 'Loading your workspace…',
  redirecting: 'Redirecting to sign-in…',
  bootstrapFailedTitle: "We couldn't load your workspace",
  bootstrapFailedBody:
    "CNP PowerForms didn't respond as expected, so sign-in can't start. Try again in a moment. If it keeps happening, contact your administrator.",
  notRegisteredTitle: "This address isn't set up for CNP PowerForms",
  notRegisteredBody: 'Check the address you opened. If it is correct, contact your administrator.',
  signInStalledTitle: "Sign-in didn't complete",
  signInStalledBody:
    "You were sent to sign in, but no session was set up when you came back. This can happen when the browser blocks this site's cookies. Sign in again. If it keeps happening, contact your administrator.",
  apiErrorTitle: "We couldn't load your page",
  apiErrorBody:
    "You're signed in, but CNP PowerForms didn't answer. Try again. If it keeps happening, contact your administrator and give them the reference below.",
  accessDeniedTitle: "You don't have access to this workspace",
  accessDeniedBody:
    "Your account signed in, but it isn't allowed to use CNP PowerForms here. Contact your administrator, or sign out and use a different account.",
  stagingLabel: 'Staging',
  navLabel: 'Main',
  navStart: 'Start Process',
  navTodo: 'To-do',
  navTracking: 'Tracking',
  navPreferences: 'Preferences',
  accountMenuLabel: 'Account',
  comingSoon: 'Coming soon',
  goToStart: 'Go to Start Process',
  todoComingSoonBody: 'Forms and tasks waiting for you will appear here.',
  trackingComingSoonBody: "Follow the progress of the forms you've submitted here.",
  appearanceHeading: 'Appearance',
  themeLabel: 'Theme',
  themeSystem: 'Match my device',
  themeLight: 'Light',
  themeDark: 'Dark',
  themeHelp: 'Applies right away and is remembered in this browser.',
  morePreferencesSoon: 'More preferences are coming soon.',
  notFoundTitle: 'Page not found',
  notFoundBody: "This page doesn't exist. Check the address, or go back to Start Process.",
  tryAgain: 'Try again',
  signInAgain: 'Sign in again',
  signOut: 'Sign out',
  reference: (ref: string) => `Reference: ${ref}`,
  categoriesHeading: 'Categories',
  allForms: 'All forms',
  selectedCategory: 'Selected category',
  searchLabel: 'Search forms',
  formsListLabel: 'Forms',
  formDetailsLabel: 'Form details',
  loadingCategories: 'Loading categories',
  loadingForms: 'Loading forms',
  loadingForm: 'Loading form details',
  categoriesErrorTitle: "We couldn't load categories.",
  formsErrorTitle: "We couldn't load forms.",
  moreErrorTitle: "We couldn't load more forms.",
  formErrorTitle: "We couldn't load this form.",
  scopeLine: (scope: string, q: string, n: number, more: boolean) => {
    const head = q ? `Results for "${q}" in ${scope}` : scope;
    const count = more ? `${n}+ forms` : n === 1 ? '1 form' : `${n} forms`;
    return `${head} · ${count}`;
  },
  noMatchTitle: (q: string) => `No forms match "${q}"`,
  noMatchBody: 'Check the spelling, or search by form code, such as CNP-2.',
  clearSearch: 'Clear search',
  emptyCategoryTitle: 'No forms in this category',
  emptyCategoryBody: 'Forms you can open will appear here when they are added.',
  showAllForms: 'Show all forms',
  noFormsTitle: 'No forms are available to you yet',
  noFormsBody:
    "Forms appear here once you're given access. Contact your administrator if you expected to see some.",
  showMore: 'Show more forms',
  selectFormPrompt: 'Select a form to see its details.',
  notAvailableTitle: "This form isn't available",
  notAvailableBody: 'It may have been withdrawn, or you may no longer have access.',
  backToForms: 'Back to forms',
  openForm: 'Open form',
  formViewsLabel: 'Form views',
  tabDetails: 'Details',
  tabForm: 'Form',
  versionN: (n: number) => `Version ${n}`,
  notProvided: 'Not provided',
  labelDescription: 'Description',
  labelCategories: 'Categories',
  labelOwner: 'Owner',
  labelDepartment: 'Owning department',
  labelSecondaryContact: 'Secondary contact',
  labelCompany: 'Company',
  labelOrdering: 'How to order printed copies',
  labelFormats: 'Formats',
  labelVersion: 'Version',
  labelPublished: 'Published',
  kindPdf: 'PDF',
  kindAdaptive: 'Online form',
  renditionPrint: 'Print PDF',
  renditionInteractive: 'Interactive PDF',
  renditionDynamic: 'Dynamic PDF',
  formPlaceholderAdaptive: 'Filling in this form online will be available here soon.',
  categoryButton: (scope: string) => `Category: ${scope}`,
  downloadsLabel: 'Downloads',
  download: (label: string) => `Download ${label}`,
  downloadHint: 'PDFs open in Adobe Acrobat or Acrobat Reader.',
  downloadError: (label: string) => `The ${label} couldn't be downloaded. Try again.`,
  previewUnavailableTitle: "A preview of this form isn't available",
  previewUnavailableBody: 'Download a PDF to view or print it.',
  loadingPages: 'Loading the form pages',
  pagesErrorTitle: "The form pages couldn't be loaded",
  formPagesLabel: 'Form pages',
  pageOf: (n: number, total: number) => `Page ${n} of ${total}`,
  previousPage: 'Previous page',
  nextPage: 'Next page',
  pageAlt: (title: string, n: number, total: number) => `${title}, page ${n} of ${total}`,
  loadingPage: (n: number) => `Loading page ${n}…`,
  pageErrorTitle: "This page couldn't be loaded.",
} as const;
